// extracted by mini-css-extract-plugin
export default {"hide-pagination":"bidA2JnjcSrDIZZfFTbi"};